import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { apibasePath } from "../config";
export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [CartCount, setCartCount] = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  // Load cart items from localStorage when the component mounts

  const fetchCartItems = async () => {
    const Token = localStorage.getItem("token");
    // if (!Token) return;
    // setRefreshing(true);
    try {
      const response = await axios.get(
        `${apibasePath}/client/customer-cart-details/`,
        {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        },
      );
      console.log("carttttreddfcgdk", response);

      // assuming response.data is an array of cart items
      const items = response.data || [];
      setCartItems(items.map((item) => item.item_tag));
      setCartCount(items.length);
      // setRefreshing(false);
    } catch (error) {
      console.error("Failed to fetch cart items:", error);
    }
  };

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cartItems")) || [];
    fetchCartItems();
    setCartItems(storedCart);
  }, []);

  // Update localStorage whenever cartItems changes
  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  // const cartCount = cartItems.length;

  const refreshCart = () => {
    fetchCartItems();
  };

  // const [, setfirst] = useState(second)

  

  const value = {
    cartItems,
    setCartItems,
    CartCount,
    refreshCart, // Expose the refresh function
    isRefreshing: refreshing, // Optionally expose the refreshing state
  };

  return (
    <CartContext.Provider value={{ cartItems, setCartItems, CartCount }}>
      {children}
    </CartContext.Provider>
  );
};